import 'swiper/css';
import 'swiper/css/navigation';

import Image from 'next/image';
import { useRouter } from 'next/router';
import React, { useLayoutEffect, useState } from 'react';
import tikipalLogo from '../public/logo-circle.svg';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import Link from 'next/link';

type NewCarouselProps = {
  spaces: SpaceType[];
  showMoreButton?: boolean;
};

function toTitleCase(str: string) {
  return str.replace(/\w\S*/g, function (txt: string) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}

export default function NewCarousel({
  spaces,
  showMoreButton,
}: NewCarouselProps) {
  const router = useRouter();
  const [slidesPerView, setSlidesPerView] = useState(3);
  const referral = router.query.referral;

  useLayoutEffect(() => {
    if (window) {
      const computeSlidesPerview = () => {
        if (window.innerWidth <= 640) {
          setSlidesPerView(3);
        } else if (window.innerWidth >= 640 && window.innerWidth <= 1024) {
          setSlidesPerView(5);
        } else {
          setSlidesPerView(7);
        }
      };
      window.addEventListener('resize', () => {
        computeSlidesPerview();
      });
      computeSlidesPerview();
    }
  }, []);

  const getLink = (slug: string) => {
    if (referral) {
      return `/${slug}?referral=${referral}`;
    }
    return `/${slug}`;
  };

  return (
    <div className="relative">
      <Swiper
        cssMode
        navigation={true}
        modules={[Navigation]}
        className="!px-8"
        slidesPerView={slidesPerView}
      >
        {spaces.map(({ name, logo, profile_image, slug }, idx) => (
          <SwiperSlide key={idx}>
            <Link
              href={getLink(slug)}
              rel={referral ? 'alternate' : 'canonical'}
              prefetch={false}
              id={`${slug}-new-carousel`}
            >
              <div className="flex flex-col p-4 items-center">
                <div className="cursor-pointer flex justify-center items-center border-copper border rounded-full overflow-hidden p-0.5">
                  <div className="flex justify-center items-center border-copper border rounded-full overflow-hidden p-0.5">
                    <div className="relative rounded-full overflow-hidden h-20 w-20">
                      <Image
                        src={logo || profile_image || tikipalLogo}
                        alt={`logo-${name}`}
                        sizes="(max-width: 768px) 50vw,
                        (max-width: 1200px) 25vw,
                        10vw"
                        fill
                      />
                    </div>
                  </div>
                </div>
                <h2 className="text-sm text-center">{toTitleCase(name)}</h2>
              </div>
            </Link>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
